import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		padding: theme.spacing(2),
		height: `calc(100% - 48px)`,
		maxWidth: '100%',
	},

	contentWrapper: {
		height: "100%",
		overflowY: "auto", // Mudado de "hidden" para "auto" para permitir rolagem
		display: "flex",
		flexDirection: "column",
		// Adicionar estilo de scrollbar customizado se disponível
		'&::-webkit-scrollbar': {
			width: '8px',
		},
		'&::-webkit-scrollbar-track': {
			background: theme.palette.background.default,
		},
		'&::-webkit-scrollbar-thumb': {
			background: theme.palette.action.disabled,
			borderRadius: '4px',
		},
		'&::-webkit-scrollbar-thumb:hover': {
			background: theme.palette.action.active,
		},
	},
}));

const MainContainer = ({ children }) => {
	const classes = useStyles();

	return (
		<Container className={classes.mainContainer}>
			<div className={classes.contentWrapper}>{children}</div>
		</Container>
	);
};

export default MainContainer;
